import { createContext } from "react";

export type IRenderContext = {
  context: "editor" | "renderer";
  renderMedium: "screen" | "print";
  apiUrl: string;
} | null;

export const RenderContext = createContext<IRenderContext | null>(null);
